import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'

import { KVMessageDef } from './index'

/**
 * Handler for token refresh requests from Unreal.
 *
 * Unreal proactively requests a token refresh ~5 minutes before the current
 * token expires. When this message is received, we re-send the authentication
 * commands with the current (potentially already refreshed) token.
 *
 * Message shape from Unreal:
 * {
 *   type: "tokenRefreshRequest",
 *   service: "kestrelAPI" | "rolodex"
 * }
 */
export function getTokenRefreshRequestMessage(): KVMessageDef {
  return {
    type: 'tokenRefreshRequest',
    requiredData: ['service'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      if (!kv.pixelStream) return

      const service = json.service as string
      const token = kv.authToken

      if (!token) return

      if (service === 'kestrelAPI') {
        kv.pixelStream.emitUIInteraction({
          command: KestrelCommands.AUTHENTICATE_KESTREL_API,
          token,
          kestrelAPIUrl: kv.kestrelApiUrl,
          userEmail: kv.user.email,
          userName: kv.user.name,
        })
      } else if (service === 'rolodex') {
        kv.pixelStream.emitUIInteraction({
          command: KestrelCommands.AUTHENTICATE_ROLODEX,
          token,
          rolodexUrl: kv.rolodexUrl,
          userEmail: kv.user.email,
          userName: kv.user.name,
          kestrelModelEntryId: kv.kestrelModel?.id ?? '',
        })
      }
    },
  }
}
